import React, { Component } from "react";
import { ACCESS_TOKEN_NAME } from '../constants/apiContants';
import { Route } from 'react-router-dom'; 

import { Redirect } from 'react-router-dom'

class ProtectedRoute extends Component {
    render() {
        const { component: Component, ...props } = this.props


        // if (localStorage.getItem(ACCESS_TOKEN_NAME) !== null)
        //     return <Redirect to="/login" />
        // else {
        //     return (
        //         <Route path='/Welcome' component={Welcome} />
        //     );
        // }
        return(
            
        <Route 
        {...props} 
            render={props => (
            localStorage.getItem(ACCESS_TOKEN_NAME) ?
            <Component {...props} /> :
            <Redirect to='/login' />
        )} 
      />
      )
    }
}
export default ProtectedRoute;
